import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DescriptionAddonPriceText = styled.div.attrs({
  id: 'descriptionAddonPriceText',
})<React.CSSProperties>`
  font-family: ${Fonts['bold']};
  color: ${Colors['promo']};
  font-size: ${Screen.widthRatio * 32}px;
  margin-top: ${Screen.widthRatio * 24}px;
`;

export default DescriptionAddonPriceText;
